import React from 'react';
import classNames from 'classnames';

import css from './IconEmail.module.css';

/**
 * Email / mail envelope icon (stroke-based).
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @param {string?} props.ariaLabel accessible label for the icon
 * @returns {JSX.Element} SVG icon
 */
const IconEmail = props => {
  const { rootClassName, className, ariaLabel } = props;
  const classes = classNames(rootClassName || css.root, className);
  const ariaLabelMaybe = ariaLabel ? { 'aria-label': ariaLabel } : {};

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      role="img"
      {...ariaLabelMaybe}
    >
      <path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7" />
      <rect x="2" y="4" width="20" height="16" rx="2" />
    </svg>
  );
};

export default IconEmail;
